export default __webpack_public_path__ + "static/media/img1.bc3db374.jpg";